<template>
  <div id="lineup">
    <div class="lineup-list">
      <h2>
        LINEUP
        <span>販売中物件</span>
      </h2>
      <Cpspring />
      <swiper
        :slides-per-view="4.5"
        :space-between="80"
        :pagination="true"
        :breakpoints="breakpoints"
        :modules="modules"
      >
        <swiper-slide v-for="(item, i) in lineuplist" :key="i">
          <LineupCard :locate="item.locate" :id="item.id" />
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import LineupCard from "@/components/PartsLineupCard.vue";
import { Pagination } from "swiper";

import Cpspring from "@/components/Cp_24spring.vue";
export default {
  data() {
    return {
      lineuplist: [
        { locate: "jikiba5", id: "jikiba5a" },
        { locate: "jikiba5", id: "jikiba5b" },
        { locate: "jikiba5", id: "jikiba5c" },
      ],
    };
  },
  components: {
    LineupCard,
    Swiper,
    SwiperSlide,
    Cpspring,
  },
  setup() {
    return {
      modules: [Pagination],
      breakpoints: {
        320: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        640: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        960: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
        1280: {
          slidesPerView: 5,
          spaceBetween: 40,
        },
        1560: {
          slidesPerView: 6,
          spaceBetween: 40,
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped>
#lineup {
  width: 100%;
  height: 100%;
  background-color: #eee;
  background-image: url("@/assets/images/common/bg_lineup.jpg");
  background-size: cover;
  padding: $v-gap 0;
  overflow: hidden;
  margin-top: calc($v-gap/2);
  h2 {
    font-weight: bold;
    font-size: 3rem;
    margin-bottom: 1em;
    span {
      margin-left: 1em;
      font-size: 1rem;
    }
  }
}
.lineup-list {
  padding: 0 $h-gap;
  @include tb {
    grid-template-columns: repeat(3, 1fr);
  }
  @include sp {
    grid-template-columns: repeat(2, 1fr);
  }
  .swiper {
    overflow: visible;
  }
}
</style>
